import { Injectable, inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from '@environment';
import type { ChangePasswordPayload } from '../models/change-password-payload.model';

@Injectable({
  providedIn: 'root',
})
export class PasswordApiService {
  private readonly http = inject(HttpClient);

  public changePassword(userId: number, payload: ChangePasswordPayload) {
    return this.http.put(`${environment.restEndpoint}/user/${userId}/password`, payload);
  }
}
